import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import DcForm from '../../component/dccore-form/dcForm.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'

if ($('#supplier_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#supplier_form',
    components: {
      RingLoader,
      DcForm
    },
    mixins: [mixins],
    data: {
      loading: 0,
      supplierId: null,
      form: {
        rows: [
          {
            type: 'header',
            content: {
              title: Translator.trans('form.general_information')
            }
          },
          {
            type: 'row',
            cols: [
              {
                type: 'text',
                content: {
                  name: 'name',
                  title: Translator.trans('supplier.entity.name'),
                }
              },
              {
                type: 'text',
                content: {
                  name: 'shortName',
                  title: Translator.trans('supplier.entity.short_name'),
                }
              },
            ],
          },
          {
            type: 'row',
            cols: [
              {
              },
              {
                type: 'text',
                content: {
                  name: 'country',
                  title: Translator.trans('supplier.entity.country'),
                }
              },
            ],
          },
          {
            type: 'row',
            cols:
              [
                {
                  type: 'text',
                  content: {
                    name: 'nip',
                    title: Translator.trans('supplier.entity.nip'),
                  }
                },
                {
                  type: 'text',
                  content: {
                    name: 'street',
                    title: Translator.trans('supplier.entity.street'),
                  }
                },
              ],
          },
          {
            type: 'row',
            cols:
              [
                {
                  type: 'text',
                  content: {
                    name: 'postCode',
                    title: Translator.trans('supplier.entity.postCode'),
                  }
                },
                {
                  type: 'text',
                  content: {
                    name: 'city',
                    title: Translator.trans('supplier.entity.city'),
                  }
                },
              ],
          },
          {
            type: 'row',
            cols:
              [

                {
                  type: 'text',
                  content: {
                    name: 'patron',
                    title: Translator.trans('supplier.entity.patron'),
                  }
                },
                {
                  type: 'tel',
                  content: {
                    name: 'patronPhone',
                    title: Translator.trans('supplier.entity.patron_phone'),
                  }
                },
              ],
          },
          {
            type: 'row',
            cols:
              [
                {
                  type: 'text',
                  content: {
                    name: 'patronEmail',
                    title: Translator.trans('supplier.entity.patron_email'),
                  }
                },
                {
                  type: 'text',
                  content: {
                    name: 'paymentTerm',
                    title: Translator.trans('supplier.entity.payment_term'),
                  }
                },
              ],
          },
          {
            type: 'row',
            cols:
              [
                {
                  type: 'text',
                  content: {
                    name: 'firstEmail',
                    title: Translator.trans('supplier.entity.firstEmail'),
                  }
                },
                {
                  type: 'checkbox',
                  content: {
                    name: 'firstEmailIsActive',
                    title: Translator.trans('supplier.entity.firstEmailIsActive'),
                  }
                },
              ],
          },
          {
            type: 'row',
            cols:
              [
                {
                  type: 'text',
                  content: {
                    name: 'secondEmail',
                    title: Translator.trans('supplier.entity.secondEmail'),
                  }
                },
                {
                  type: 'checkbox',
                  content: {
                    name: 'secondEmailIsActive',
                    title: Translator.trans('supplier.entity.secondEmailIsActive'),
                  }
                },
              ],
          },
          {
            type: 'row',
            cols:
              [
                {
                  type: 'tel',
                  content: {
                    name: 'firstContactPhone',
                    title: Translator.trans('supplier.entity.first_contact_phone'),
                  }
                },
              ],
          },
          {
            type: 'row',
            cols:
              [
                {
                  type: 'tel',
                  content: {
                    name: 'secondContactPhone',
                    title: Translator.trans('supplier.entity.second_contact_phone'),
                  }
                },
              ],
          },
          {
            type: 'row',
            cols:
              [
                {
                  type: 'checkbox',
                  content: {
                    name: 'active',
                    title: Translator.trans('supplier.entity.active'),
                  }
                },
              ],
          },
        ],
        entity: {},
        options: {
          errors: {},
        }

      },
    },
    mounted: function () {
      if ($('#entity_id').length) {
        this.supplierId = $('#entity_id').val()
        this.getSupplier()
      }
    },
    methods: {
      createSupplier: function (redirect) {
        //this.buttonSave.button('loading');
        let url = Routing.generate('api_post_supplier')

        this.$http.post(url, { 'data': this.form.entity }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('supplier_grid'))
          } else {
            toastr.success(Translator.trans('supplier.create.created'))
          }

        }, response => {
          this.handleAjaxError(response, this.form.options)
        })

      },
      updateSupplier: function (redirect) {
        let url = Routing.generate('api_patch_supplier', { id: this.supplierId })

        this.$http.patch(url, { 'data': this.form.entity }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('supplier_grid'))
          } else {
            this.form.options.errors = {}
            toastr.success(Translator.trans('supplier.update.updated'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      getSupplier: function () {
        let url = Routing.generate('api_get_supplier', {
          id: this.supplierId,
          context: 'edit'
        })

        this.$http.get(url).then(response => {
          this.form.entity = response.data
        }, response => {
          this.handleAjaxError(response)
        })
      },
    }

  })
}
